var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/** @jsx jsx */


import ArrowLeft from "mdi-material-ui/ArrowLeft";
import ArrowLeftCircleOutline from "mdi-material-ui/ArrowLeftCircleOutline";
import ArrowRight from "mdi-material-ui/ArrowRight";
import ArrowRightCircleOutline from "mdi-material-ui/ArrowRightCircleOutline";
import ChevronLeft from "mdi-material-ui/ChevronLeft";
import ChevronRight from "mdi-material-ui/ChevronRight";
import MenuLeft from "mdi-material-ui/MenuLeft";
import MenuRight from "mdi-material-ui/MenuRight";
import { memo } from "react";
import { jsx } from "theme-ui";

var Arrow = function Arrow(_a) {
  var direction = _a.direction,
      onClick = _a.onClick,
      arrowType = _a.arrowType,
      arrowPosition = _a.arrowPosition;
  var components = [null, null];

  switch (arrowType) {
    default:
    case "arrow-circle-outline":
      components = [jsx(ArrowLeftCircleOutline, {
        key: "previous",
        fontSize: "inherit"
      }), jsx(ArrowRightCircleOutline, {
        key: "next",
        fontSize: "inherit"
      })];
      break;

    case "arrow":
      components = [jsx(ArrowLeft, {
        key: "previous",
        fontSize: "inherit"
      }), jsx(ArrowRight, {
        key: "next",
        fontSize: "inherit"
      })];
      break;

    case "chevron":
      components = [jsx(ChevronLeft, {
        key: "previous",
        fontSize: "inherit"
      }), jsx(ChevronRight, {
        key: "next",
        fontSize: "inherit"
      })];
      break;

    case "menu":
      components = [jsx(MenuLeft, {
        key: "previous",
        fontSize: "inherit"
      }), jsx(MenuRight, {
        key: "next",
        fontSize: "inherit"
      })];
      break;
  }

  var arrowSx = {
    lineHeight: 0,
    cursor: "pointer",
    opacity: 0.5,
    "&:hover": {
      opacity: 1
    }
  };

  if (arrowPosition === "inside") {
    arrowSx = __assign(__assign({}, arrowSx), {
      backgroundColor: "rgba(0,0,0,.5)",
      borderRadius: "100%",
      color: "#fff",
      fontSize: 6
    });
  }

  if (arrowPosition === "outside") {
    arrowSx = __assign(__assign({}, arrowSx), {
      alignItems: "center",
      display: "flex",
      fontSize: 5,
      height: "100%"
    });
  }

  return jsx("div", {
    onClick: onClick,
    sx: arrowSx
  }, direction === "previous" ? components[0] : components[1]);
};

export default memo(Arrow);